<section class="hero">
  <div class="container">
    <div class="mascot">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 content">
          <div class="hero-text dsk">
            <div class="tickets"> {{"homePage.homeBanner.ticket" | i18n }}</div>
            {{"homePage.homeBanner.title" | i18n }}
            <span class="booking desktop">{{"homePage.homeBanner.booking" | i18n }}</span>
          </div>
          <div class="hero-text tablet">
            <div class="tickets">{{"homePage.homeBanner.ticket" | i18n }}</div>
            {{"homePage.homeBanner.title" | i18n }}
            <span class="booking desktop">{{"homePage.homeBanner.booking" | i18n }}</span>
          </div>
          <div class="hero-text mobile">
            <div class="tickets">{{"homePage.homeBanner.ticket" | i18n }}</div>
            {{"homePage.homeBanner.title" | i18n }}
            <span class="booking desktop">{{"homePage.homeBanner.booking" | i18n }}</span>
          </div>

          <div class="hero-text-small">{{"homePage.homeBanner.tagLine"| i18n }}</div>
          <span class="booking mobile">{{"homePage.homeBanner.booking" | i18n }}</span>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 img-hr">
          <img src="assets/images/mascot.png">
        </div>
      </div>
    </div>
  </div>
</section>